/* eslint-disable @typescript-eslint/no-require-imports */
// Picked up by webpack, Rollup or any other Web bundler

// Helper to get a secure random integer [0, max)
export const getSecureRandomInt = (max: number): number => {
  if (max <= 0) {
    throw new Error('max must be greater than 0');
  }

  const array = new Uint32Array(1);
  crypto.getRandomValues(array);

  return array[0] % max;
};
